<ng-container>
    @if(isOpen()){
    <div class="wrap">
        <h3>Achtung</h3>

        <ul>
            <li>Bivalenzpunkte und Alternativpunkt auf maximalen Wert stellen</li>
            <li>Bei endgültiger Inbetriebnahme Parameter wieder anpassen</li>
        </ul>
        <br /><br />
        <ul>
            <li>
                Weitere Bedienugung wie Simulator mit Außeneinheit "stand alone" oder "Regler".
                Parameter D.127 "Kühlen möglich" und Prüfprogramme der Außeneinheit werden nicht
                angezeigt. Anzeige Datenpunkte der Außeneinheit mit Defaultwerten.
            </li>
        </ul>
        <br>
    </div>
    }
</ng-container>